import { Button, Form, Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Turnstile, { useTurnstile } from "react-turnstile";
import {
  resetStatus,
  selectAuth,
  forgotPassword,
} from "../../redux/reducers/slice/auth";
import "./style.scss";
import { isPhoneNumber, isRequired } from "../fields/validator";
import ForgotPasswordModal from "../modal/forgotPasswordModal";
import { useTranslation } from "react-i18next";
import { setTitlePage } from "../../utils/helper";
import { CLOUDFLARE_SITE_KEY } from "../../utils/constant";

const AuthForgotPassword = (props: any) => {
  const { type, setNameAuthModal } = props;

  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>("");
  const { t } = useTranslation();
  const turnstile = useTurnstile();

  useEffect(() => {
    if (type !== "MODAL") {
      setTitlePage(t("title_page_forgot_password"));
    }

    dispatch(resetStatus());
  }, []);

  const handleOnVerify = (token: string) => {
    setCaptchaToken(token);
  }

  const onHandleErrorTurnstile = (error: any) => {
    setCaptchaToken(null);
    turnstile?.reset();
  }

  const handleSubmit = async (values: any) => {
    await dispatch(
      await forgotPassword({
        username: values.phoneNumber,
        token: captchaToken
      }, onHandleErrorTurnstile)
    );

    setVisible(true);
  };

  return (
    <div>
      <div className="kd-forgot-password-form-content center">
        <span className="kd-name-component">
          {t("title_screen_forgot_password")}
        </span>
      </div>

      <Form
        className="kd-forgot-password-form-content center"
        size="large"
        name="loginForm"
        onFinish={(values) => handleSubmit(values)}>
        <Form.Item
          className="kd-forgot-password-form-item"
          name="phoneNumber"
          rules={[isRequired, isPhoneNumber]}>
          <Input className="input" addonBefore={t("field_phone_number")} />
        </Form.Item>
        <Form.Item>
          <Turnstile
            sitekey={`${CLOUDFLARE_SITE_KEY}`}
            onSuccess={handleOnVerify}
            onError={onHandleErrorTurnstile}
            onExpire={onHandleErrorTurnstile}
            onTimeout={onHandleErrorTurnstile}
            theme="light"
            refreshExpired="auto"
          />
        </Form.Item>

        <Form.Item noStyle>
          {auth.loading ? (
            <Spin size="large" />
          ) : (
            <Button
              className="kd-forgot-password-form-button kd-btn-primary-2"
              type="primary"
                loading={!captchaToken}
                disabled={!captchaToken}
              htmlType="submit">
              {t("btn_forgot_password")}
            </Button>
          )}
        </Form.Item>
      </Form>

      <ForgotPasswordModal
        {...props}
        visible={visible}
        setVisible={setVisible}
        type={type}
        setNameAuthModal={setNameAuthModal}
      />
    </div>
  );
};

export default AuthForgotPassword;
